import { render, staticRenderFns } from "./TagsContainer.vue?vue&type=template&id=758fb870&scoped=true"
import script from "./TagsContainer.vue?vue&type=script&lang=js"
export * from "./TagsContainer.vue?vue&type=script&lang=js"
import style0 from "./TagsContainer.vue?vue&type=style&index=0&id=758fb870&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758fb870",
  null
  
)

export default component.exports